export enum UserType {
  Visitor = 'Visitor',
  User = 'User',
  Customer = 'Customer',
}

export default UserType;